module.exports = __webpack_public_path__ + "LGFacad_1.8a08c1e0.png";